import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

import { ServiceGroup } from "../../Models/ServiceGroup";

interface Props {
  disabled?: boolean;
  options: Pick<ServiceGroup, "service" | "disabled">[];
  serviceId?: string;
  setService: (service: Pick<ServiceGroup, "service" | "disabled">) => void;
}

const BookingWizardServiceSelector: React.FC<Props> = ({ disabled = false, options, serviceId, setService }: Props) => (
  <FormControl>
    <InputLabel shrink>Service</InputLabel>
    <Select
      disabled={disabled}
      value={serviceId || ""}
      label="Service"
      onChange={({ target: { value } }) => setService(options.find(s => s.service?.id === value) as ServiceGroup)}
      displayEmpty
    >
      {options.map(({ service: { id, name }, disabled }, key) => (
        <MenuItem value={id} key={key} disabled={disabled}>
          {name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default BookingWizardServiceSelector;
